import axios, { AxiosRequestConfig } from 'axios';

import NV05FormListData from '../models/payload/NV05FormListData';
import CSharpUtils from './CSharpUtils';
import U from './Utils';

const _timeOut = 300000;

export const APIgetProductgroupListByFirm = (formData: NV05FormListData) => {
  const config = {
    method: 'post',
    baseURL: `${`${U.URL_ADDRESS}${U.DOTNET_DEV_SERVICE}`}/NV05/productListByFirm`,
    maxContentLength: 1000000,
    timeout: _timeOut,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    data: formData,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
};

// Excel
export const APIgetNV05ExcelData = (formData: NV05FormListData) => {
  const config = {
    method: 'post',
    baseURL: `${`${U.URL_ADDRESS}${U.DOTNET_DEV_SERVICE}`}/NV05/ExportToExcel`,
    maxContentLength: 1000000,
    timeout: _timeOut,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`, 
    },
    data: formData,
    responseType: 'blob',
    responseEncoding: 'utf8',
    withCredentials: false,
    secure: false,
    changeOrigin: true,
    mode: 'no-cors',
  } as AxiosRequestConfig;
  return axios.request(config);
  /**/
};

